//import React from "react";
import "./ReportSecondSection.css";

const ReportSecondSection = ({res}) => {
    //const res=JSON.parse(localStorage.getItem("scorecardData"))
  return (
    <div className="report-second-section">
     
        <h2 className="info-report-heading">
          MarsMate AI - Idea Validation Report
        </h2>

        <div className="info-report-details">
          {/* Row 1 */}
          <div className="info-report-row">
            <div className="info-left">
              <strong>Startup Title:</strong> {res?.companyName??"Synosphere"}
            </div>
            <div className="info-right">
              <strong>Email:</strong> {res?.companyEmail??'info@synosphere.com'}
            </div>
          </div>

          {/* Row 2 */}
          <div className="info-report-row">
            <div className="info-left">
              <strong>Person Name:</strong> {res?.fullName??"abhinav"}
            </div>
            <div className="info- right">
              <strong>Phone Number:</strong> {res?.contact??'9182734065'}
            </div>
          </div>

          {/* Row 3 */}
          <div className="info-report-row">
            <div className="info-left">
              <strong>Website:</strong> {res?.website??'synosphereglobal.com'}
            </div>
            <div className="info-right"></div>
          </div>
        </div>
        <hr className="info-divider" />
        <h2 className="info-subheading">Executive Summary</h2>
        <p className="info-summary-text">
          {res?.sectionScores?.aiReport?.executiveSummary || 
           res?.sectionScores?.ai_report?.executiveSummary ||
           res?.aiReport?.executiveSummary ||
           "Demonstrates exceptional innovation, strong market need, and full validation across all modules — investor and incubation ready. Proceed to incubation, investor pitching, or funding round."}
        </p>
        {(res?.sectionScores?.aiReport?.crossCheckSummary || res?.sectionScores?.ai_report?.crossCheckSummary || res?.aiReport?.crossCheckSummary) && (
          <>
            <hr className="info-divider" />
            <h2 className="info-subheading">AI & Rule-Based Cross-Check Summary</h2>
            <p className="info-summary-text">
              {res?.sectionScores?.aiReport?.crossCheckSummary || res?.sectionScores?.ai_report?.crossCheckSummary || res?.aiReport?.crossCheckSummary}
            </p>
          </>
        )}
      
    </div>
  );
};

export default ReportSecondSection;
